import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ModalService, ConfirmationModalComponent } from '../../../shared/modules/modal';
import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';

import {
  Message,
  TransactionComparability,
  ComparabilityModalPayload,
  ComparabilityOption,
  EvaluateComparabilityValidationErrorResponse
} from '../../../shared/models';

import { NotificationService, TransactionsComparabilityService } from '../../../shared/services';

import { TinyTextEditor } from '../../../shared/constants';

@Component({
  selector: 'evaluate-comparability-modal',
  templateUrl: './evaluate-comparability-modal.component.html',
})
export class EvaluateComparabilityModalComponent
  extends ClosableModalWithErrorResponseModel<EvaluateComparabilityValidationErrorResponse>
  implements OnInit, OnDestroy {

  data: ComparabilityModalPayload;
  transactionComparability: TransactionComparability = new TransactionComparability();
  options: ComparabilityOption[] = [];

  tinyInit = TinyTextEditor.INIT;

  constructor(protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _comparabilityService: TransactionsComparabilityService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new EvaluateComparabilityValidationErrorResponse();
  }

  ngOnInit() {
    this.listenForErrorMessages();
    this.getTransactionComparability();
    this.getOptions();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this._comparabilityService.editTransactionComparabilityEvaluate(this.transactionComparability).subscribe(() => {
      this.closeAllModals();
      this.success();
    });
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Close Evaluate Comparability',
          content: 'Are you sure you want to cancel your actions and close it?',
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  markFormAsTouched(form: NgForm): void {
    form.form.markAsTouched();
  }

  private getTransactionComparability(): void {
    this._comparabilityService.show(this.data.transactionComparabilityId).subscribe((res) => {
      this.transactionComparability = res.result.transactionComparability;
    });
  }

  private getOptions(): void {
    this._comparabilityService.getTransactionComparabilityOptions().subscribe((res) => {
      this.options = res.result.comparabilityOptions;
    });
  }
}
